module.exports = __webpack_public_path__ + "static/media/nip-approved.2f117fe3.svg";